/**
 * A share link's address is `/s/<link id>#<secret>` (`crates/services/identity/src/links/secret.rs`): the path names
 * the link and the fragment holds its secret, so neither the static host's logs nor any Referer ever carry it. The
 * identity API takes both as one token, `<link id>#<secret>`; the demo's links have no fragment.
 */
export function linkToken(path: string, hash: string): string {
  const secret = hash.startsWith("#") ? hash.slice(1) : hash;
  return secret === "" ? path : `${path}#${secret}`;
}

/** Splits a token back into the link's ID and its secret (`""` when it has none). */
export function splitLinkToken(token: string): { link: string; secret: string } {
  const at = token.indexOf("#");
  return at < 0
    ? { link: token, secret: "" }
    : { link: token.slice(0, at), secret: token.slice(at + 1) };
}
